'use strict';

// Variables
const CONFIG = {
    SELECTOR: {
        HIDDEN: '.hidden',
        READ_MORE: '.read-more',
        SIDE_DESCRIPTION: '.side-description',
        TEXT_BREAK: '.text-break'
    },
    READ_MORE_TEXT: $('.side-description').attr('data-read-more'),
    READ_LESS_TEXT: $('.side-description').attr('data-read-less'),
    MAX_LENGTH: 300
};

/**
 * Function to truncate long text and add a "read more" link to reveal the rest of the text.
 * @function pdpReadMore
 */
function pdpReadMore() {
    $(CONFIG.SELECTOR.SIDE_DESCRIPTION).each(function () {
        var text = $(this).text();
        if (text.length > CONFIG.MAX_LENGTH) {
            var begin = text.substr(0, CONFIG.MAX_LENGTH);
            var end = text.substr(CONFIG.MAX_LENGTH);

            $(this)
                .html(begin)
                .append($('<span class="text-break" style="display: inline"/>').html('...'))
                .append($('<span class="hidden" style="display: none"/>').html(end))
                .append($('<a href="#" class="read-more" style="margin: 0 5px"/>').html(CONFIG.READ_MORE_TEXT));
        }
    });

    $(document).on('click', CONFIG.SELECTOR.READ_MORE, function () {
        $(this).siblings(CONFIG.SELECTOR.HIDDEN).slideToggle(40);
        $(this).siblings(CONFIG.SELECTOR.HIDDEN).css('display', 'hidden');
        $(this).siblings(CONFIG.SELECTOR.TEXT_BREAK).slideToggle(40);
        $(this).siblings(CONFIG.SELECTOR.TEXT_BREAK).css('display', 'none');
        $(this).text($(this).text() === CONFIG.READ_MORE_TEXT ? CONFIG.READ_LESS_TEXT : CONFIG.READ_MORE_TEXT);
    });
}

module.exports = {
    pdpReadMore: pdpReadMore
};
